import {Module, Mutation, MutationAction, VuexModule} from "vuex-module-decorators";
import {Championship, ChampionshipRef} from "@/modules/championship/services/PublicChampionshipService";
import {
    ChampionshipSecurityData,
    manageChampionshipService
} from "@/modules/championship/services/ManageChampionshipService";

@Module({namespaced: true, name: 'championship-manage'})
export default class ManageChampionshipModule extends VuexModule {
    championship: Championship = {} as Championship
    security: ChampionshipSecurityData = {} as ChampionshipSecurityData

    @Mutation
    clearStore() {
        this.championship = {} as Championship
    }

    @MutationAction
    async loadChampionship(ref: ChampionshipRef) {
        const championship = await manageChampionshipService.getChampionship(ref)
        return {championship: championship}
    }

    @MutationAction
    async loadSecurityCodes(ref: ChampionshipRef) {
        const data = await manageChampionshipService.getSecurity(ref)
        return {security: data}
    }
}
